import { Injectable } from '@angular/core';
import { UserStateDataEntryValue } from '@osos/shared/api';
import { UserStateDataPresenterModel } from '@osos/shared/types';
import { FactoryBase } from '../../bases';
import { UserStateDataParserV1Service } from '../../parsers/user-state-data-entry-parser/user-state-data-parser-v1.service';
import { ParserFactory } from '../../services';

@Injectable({
  providedIn: 'root',
})
export class UserStateDataEntryFactoryService extends FactoryBase<
  UserStateDataEntryValue,
  UserStateDataPresenterModel
> {
  constructor(
    parserFactory: ParserFactory,
    parser_v1: UserStateDataParserV1Service,
  ) {
    super(parserFactory);
    // register the related parsers within the parser factory:
    parserFactory.register(parser_v1);
  }
  override createPresenterModel(
    model: UserStateDataEntryValue,
  ): UserStateDataPresenterModel {
    const parser = this.getParser(
      UserStateDataEntryValue,
      UserStateDataPresenterModel,
    );
    const result = parser.getPresenterModel(model);
    return result;
  }
  override createDataModel(
    presenter: UserStateDataPresenterModel,
  ): UserStateDataEntryValue {
    const parser = this.getParser(
      UserStateDataEntryValue,
      UserStateDataPresenterModel,
    );
    const result = parser.getDataModel(presenter);
    return result;
  }
}
